package uz.ferro.erp.feature.alert

import react.createContext
import uz.ferro.erp.error.HttpException

interface AlertManagerHost {
    fun onSuccessMessage(message: String)
    fun onErrorMessage(message: String)
}

class AlertManager(val host: AlertManagerHost? = null) {

    fun handleError(e: Exception) {
        if (e is HttpException && e.errorResponse.isNotBlank()) {
            showError(e.errorResponse)
        } else {
            e.printStackTrace()
            showError("Noma'lum xatolik")
        }
    }

    fun showSuccess(message: String) {
        host?.onSuccessMessage(message)
    }

    fun showError(message: String) {
        host?.onErrorMessage(message)
    }
}

val AlertManagerContext = createContext(AlertManager())

enum class AlertType {
    ERROR,
    SUCCESS
}

data class AlertMessage(
    val type: AlertType,
    val message: String
)